import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './schadenfaelle.module.scss';

import {schadenfaelleRun} from './schadenfaelle.route';
import {SchadenfaelleListViewComponentConfig} from './component/schadenfaelleListView';


export const SerfWebSchadenfaelle = angular.module('serfWeb.schadenfaelle', [SerfWebCore.name])
    .component('schadenfaelleView', new SchadenfaelleListViewComponentConfig())
    .run(schadenfaelleRun);

export default SerfWebSchadenfaelle;



// WEBPACK FOOTER //
// ./src/app/schadenfaelle/schadenfaelle.module.ts